import React from 'react';
import { Space, Input, Button, Select } from 'antd';
import { Label } from '../../Layouts';
import GatewaySelect from '../../common/GatewaySelect';

const LogFilter: React.FC<{
    values: Partial<GlobalDeviceSearchParams>,
    onSearch: () => void,
    onChange: (v: Partial<GlobalDeviceSearchParams>) => void,

}> =
    ({ values: params, onChange: setParams, onSearch }) => {
        return (
            <Space>
                <Label>
                    <Label>设备序列号</Label>
                    <Input.Search allowClear style={{ width: 300 }} placeholder='请输入设备序列号' value={params.devSn}
                        onSearch={onSearch}
                        onChange={e => {
                            setParams({
                                ...params,
                                devSn: e.target.value
                            })
                        }} />
                </Label>
                <Label>
                    <Label>MAC地址</Label>
                    <Input.Search allowClear style={{ width: 300 }} placeholder='请输入MAC地址' value={params.deviceMac}
                        onSearch={onSearch}
                        onChange={e => {
                            setParams({
                                ...params,
                                deviceMac: e.target.value
                            })
                        }} />

                </Label>
                {/* <Label>
                    <Label>网络类型</Label>
                    <Select allowClear placeholder='请选择' style={{width: 100}} options={[
                        { label: '4G', value: '4G' },
                        { label: '5G', value: '5G' },
                    ]}
                        onChange={e => {
                            setParams({
                                ...params,
                                type: e
                            })
                        }}
                    />
                </Label> */}

                <Button onClick={onSearch} style={{ marginTop: '1.4em' }} type='primary'>查询</Button>
            </Space>
        );
    }

export default LogFilter;